var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandAssignment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.4285 4.85938C11.7857 4.85938 12.1428 5.21652 12.1428 5.57366C12.1428 5.9308 11.7857 6.28795 11.4285 6.28795C11.0714 6.28795 7.85711 6.28795 7.85711 6.28795C7.06813 6.28795 6.42854 6.92754 6.42854 7.71652L6.42854 16.2879C6.42854 17.0769 7.06813 17.7165 7.85711 17.7165L11.4285 17.7165C11.823 17.7165 12.1428 18.0363 12.1428 18.4308C12.1428 18.8253 11.823 19.1451 11.4285 19.1451L7.85711 19.1451C6.27915 19.1451 4.99997 17.8659 4.99997 16.2879L4.99996 7.71652C4.99996 6.13856 6.27915 4.85938 7.85711 4.85938C7.85711 4.85938 11.0714 4.85938 11.4285 4.85938Z",
    fill: "#B0B7C3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 10,
    y: 12.7109,
    width: 1.42857,
    height: 10,
    rx: 0.714286,
    transform: "rotate(-90 10 12.7109)",
    fill: "#B0B7C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0764 15.0697C14.3554 15.3486 14.3554 15.8009 14.0764 16.0799C13.7975 16.3588 13.3452 16.3588 13.0663 16.0799L9.49486 12.5084C9.22623 12.2398 9.21487 11.8079 9.46901 11.5255L12.6833 7.95409C12.9472 7.66087 13.3988 7.6371 13.692 7.901C13.9853 8.16489 14.009 8.61653 13.7451 8.90975L10.9842 11.9775L14.0764 15.0697Z",
    fill: "#B0B7C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandAssignment);
export default __webpack_public_path__ + "static/media/stand-assignment.dc6a494eff6ea69abc4c6ca029263cf1.svg";
export { ForwardRef as ReactComponent };